import humanparser from 'humanparser';
import PropTypes from 'prop-types';
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import CurrentUser from 'auth/CurrentUser';
import DialogContent from 'components/DialogContent';
import FormDeprecated from 'components/FormDeprecated';
// @ts-ignore
import FormInput from 'components/FormInput';
import ToastActions from 'actions/ToastActions';
// @ts-ignore
import UserActions from 'user/UserActions';

type State = {
  enabled: boolean;
};

class SetupFullName extends React.Component<{}, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    enabled: false,
  };

  submit = (attrs: { full_name: string }) => {
    const human = humanparser.parseName(attrs['full_name']);
    const data = {
      first_name: human.firstName,
      last_name: human.lastName,
    };

    const onSuccess = () => {
      ToastActions.showSuccessToast('Saved!');
      this.context.router.push('/');
    };

    const onFailure = (error: Error) => ToastActions.showAPIError(error);

    UserActions.update(data).then(onSuccess, onFailure);
  };

  render() {
    const user = CurrentUser.getUser();
    let fullName = '';

    if (user.getFirstName() && user.getLastName()) {
      fullName = user.getFirstName() + ' ' + user.getLastName();
    } else {
      fullName = user.getFirstName() || user.getLastName() || '';
    }

    return (
      <DialogContent size="small" className="SetupFullName" title={'What’s your name?'}>
        <BoxBody divided>
          <FormDeprecated
            onValidSubmit={this.submit}
            onValid={() => this.setState({ enabled: true })}
            onInvalid={() => this.setState({ enabled: false })}>
            <div className="SetupFullName-First">
              <FormInput
                label="Full name"
                required
                name="full_name"
                showErrorOnPristine={false}
                value={fullName}
                placeholder="First and last name"
                validations={{
                  maxLength: 255,
                }}
                validationErrors={{
                  maxLength: 'Name should be shorter than 255 characters.',
                }}
              />
            </div>
            <Button
              disabled={!this.state.enabled}
              className="SetupFullName-Submit"
              type="submit"
              eventElementName="SetupFullName-Submit">
              Next
            </Button>
          </FormDeprecated>
        </BoxBody>
      </DialogContent>
    );
  }
}
export default SetupFullName;
